// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "tooltip-2yy_O";
var _3 = "info-3fsm8";
var _4 = "tooltip_recommend-2uUjB";
var _5 = "tooltip_withInfo-3nrn9";
var _6 = "tooltip_popper-3GuFG";
var _7 = "number-NeQKw";
var _8 = "details-oEkcy";
var _9 = "details__price-1LSI4";
var _a = "details__seatName-cKOOG";
export { _1 as "__esModule", _2 as "tooltip", _3 as "info", _4 as "tooltip_recommend", _5 as "tooltip_withInfo", _6 as "tooltip_popper", _7 as "number", _8 as "details", _9 as "details__price", _a as "details__seatName" }
export default { "__esModule": _1, "tooltip": _2, "info": _3, "tooltip_recommend": _4, "tooltip_withInfo": _5, "tooltip_popper": _6, "number": _7, "details": _8, "details__price": _9, "details__seatName": _a }
